import axios from 'axios';

const state = {
  list: {},
  fullCount: 0,
  sort: {
    field: 'name',
    direction: 'ASC',
  },
  page: {
    pageSize: 10,
    page: 1,
  },
  filter: '',
  city: '',
  county: '',
  unclaimed: false,
  lastUpdated: null,
  category: '',
  type: '',
};

const getters = {
  getLocationById: st => id => st.list.find(l => l._id === id),
};

const actions = {
  async getLocations({ commit, state: st }) {
    let url = `${process.env.VUE_APP_API_LOCATIONS_ROOT}/`;
    url += `?paging=true&page=${st.page.page}&pageSize=${st.page.pageSize}`;
    if (st.sort.field) {
      url += `&sorting=true&sortField=${st.sort.field}&sortDirection=${st.sort.direction}`;
    }
    if (st.filter && st.filter !== '') {
      url += `&filter=${st.filter}`;
    }
    if (st.city && st.city !== '') {
      url += `&city=${st.city}`;
    }
    if (st.county && st.county !== '') {
      url += `&county=${st.county}`;
    }
    if (st.unclaimed) {
      url += '&unclaimed=true';
    }
    if (st.lastUpdated) {
      url += `&lastUpdated=${st.lastUpdated}`;
    }
    if (st.category) {
      url += `&category=${st.category}`;
    }
    if (st.type) {
      url += `&type=${st.type}`;
    }

    const response = await axios.get(url);

    commit('setLocations', response.data.locations);
    commit('setCount', response.data.count);
  },
  async sortLocations({ commit, state: st, dispatch }, field) {
    if (st.sort && st.sort.field === field) {
      if (st.sort.direction === 'ASC') {
        commit('setSortDirection', 'DESC');
      } else if (st.sort.direction === 'DESC') {
        commit('setSortDirection', 'ASC');
      }
    } else {
      commit('setSortDirection', 'ASC');
      commit('setSortField', field);
    }

    await dispatch('getLocations');
  },
  async setPage({ commit, dispatch }, page) {
    commit('setPage', page);
    await dispatch('getLocations');
  },
  setFilter({ commit }, filter) {
    commit('setFilter', filter);
  },
  setCity({ commit }, city) {
    commit('setCity', city);
  },
  setCounty({ commit }, county) {
    commit('setCounty', county);
  },
  setUnclaimed({ commit }, unclaimed) {
    commit('setUnclaimed', unclaimed);
  },
  setLastUpdated({ commit }, lastUpdated) {
    commit('setLastUpdated', lastUpdated);
  },
  setCategory({ commit }, category) {
    commit('setCategory', category);
  },
  setType({ commit }, type) {
    commit('setType', type);
  },
  resetFilter({ commit }) {
    commit('setFilter', '');
    commit('setCity', '');
    commit('setCounty', '');
    commit('setUnclaimed', false);
    commit('setLastUpdated', null);
    commit('setCategory', '');
    commit('setType', '');
  },
};

const mutations = {
  setLocations(st, locations) {
    st.list = locations;
  },
  setCount(st, count) {
    st.fullCount = count;
  },
  setSortField(st, field) {
    st.sort.field = field;
  },
  setSortDirection(st, direction) {
    st.sort.direction = direction;
  },
  setPage(st, page) {
    st.page.page = page;
  },
  setFilter(st, filter) {
    st.filter = filter;
  },
  setCity(st, city) {
    st.city = city;
  },
  setCounty(st, county) {
    st.county = county;
  },
  setUnclaimed(st, unclaimed) {
    st.unclaimed = unclaimed;
  },
  setLastUpdated(st, lastUpdated) {
    st.lastUpdated = lastUpdated;
  },
  setCategory(st, category) {
    st.category = category;
  },
  setType(st, type) {
    st.type = type;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
